import {
  getRegisterUrlClientSide,
  getRegisterUrlClientSideWithJobNumber,
} from '@/app/utils/urlHelper';
import { useAuth0User } from '@/modules/Context/useAuth0User';
import { PATH } from 'constants/path';
import { useRouter } from 'next/router';
import { useAnalytics } from 'utils/useAnalytics';

import Button from '@material-ui/core/Button';

/**
 * If text "See Details/Enquiry" passed, url should be passed which is an absolute path to the job details page
 **/

type JobButtonProps = {
  id: string;
  jobNumber: string;
  treatment?: string;
  text?: string;
  url?: string;
  trackingCallback?: () => void;
  buttonSize?: 'small' | 'medium' | 'large';
  className?: string;
  addJobNumberQueryParam?: boolean;
  disableEnquireAndWithdrawButtons?: boolean;
};

export const JobButton = ({
  id,
  jobNumber,
  text = 'Enquire',
  url,
  trackingCallback,
  buttonSize = 'large',
  className,
  addJobNumberQueryParam,
  disableEnquireAndWithdrawButtons,
}: JobButtonProps) => {
  const router = useRouter();
  const track = useAnalytics();
  const { user } = useAuth0User();
  const isDisabled = disableEnquireAndWithdrawButtons && text === 'Enquire' && !!user;
  const defaultTrackingCallback = () => {
    if (disableEnquireAndWithdrawButtons && text === 'Register') {
      track('Register button clicked', { jobNumber: jobNumber });
      return;
    }
    track('Job Enquire', { jobNumber: jobNumber });
  };

  trackingCallback = trackingCallback ?? defaultTrackingCallback;

  // TODO: Tidy up this function - bit all over the place
  const onClick = async () => {
    trackingCallback && trackingCallback();
    if (text === 'See Details') {
      url ? router.push(url) : router.push(`/jobs/${id}`);
    } else if (text === 'Register') {
      router.push(PATH.REGISTER);
    } else if (user) {
      router.push(`${url}${PATH.JOB_ENQUIRE}`);
    } else {
      const redirectUrl = addJobNumberQueryParam
        ? getRegisterUrlClientSideWithJobNumber(jobNumber, `${url}${PATH.JOB_ENQUIRE}`, url)
        : getRegisterUrlClientSide('enquire_job', `${url}${PATH.JOB_ENQUIRE}`);
      router.push(redirectUrl);
    }
  };

  return (
    <Button
      className={className}
      fullWidth
      variant="contained"
      size={buttonSize}
      color="secondary"
      onClick={onClick}
      data-testid={'job-button'}
      disabled={isDisabled}
    >
      {text}
    </Button>
  );
};
